<template>
  <div class="bg">
    <div id="form-container" class="custom-wrapper">
      <div class="row container thankyou">
        <h2>Thank You For Using The Energy Use Estimator</h2>
        <div class="container">
          <p>You may use the result of this estimator, along with any other relevant information, to populate the required fields of the OLCC Supplemental Electricity And Water Use Form.</p>
          <p>Results - Indoor Cannabis Cultivator Energy Use Estimator</p>
          <table class="table table-striped">
            <tbody>
              <tr>
                <th scope="row">Cultivator Name:</th>
                <td>{{cultivatorName}}</td>
              </tr>
              <tr>
                <th scope="row">Estimated Grow Area (sq. ft):</th>
                <td>{{estTotalGrowArea}}</td>
              </tr>
              <tr>
                <th scope="row">Estimated Annual Energy Use:</th>
                <td>{{annualEnergyUseSelector}} kWh / yr</td>
              </tr>
              <tr>
                <th scope="row">Estimated Monthly Energy Use:</th>
                <td>{{monthlyEnergyUseSelector}} kWh / Mo</td>
              </tr>
              <tr>
                <th scope="row">Estimated Total Plants In Continuous Grow:</th>
                <td>{{estTotalPlants}}</td>
              </tr>
              <tr>
                <th scope="row">Energy Use Equipment Description:</th>
                <td>{{energyUseEquipmentDesc}}</td>
              </tr>
              <tr>
                <th scope="row">Actual Energy Use</th>
                <td>{{actualEnergyUse}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cultivatorName: window.$cookies.get("cultivatorName"),
      estTotalGrowArea: window.$cookies.get("estTotalGrowArea"),
      estTotalPlants: window.$cookies.get("estTotalPlants"),
      actualEnergyUse: window.$cookies.get("actualEnergyUse"),
      energyUseEquipmentDesc: window.$cookies.get("energyUseEquipmentDesc"),
      annualEnergyUseSelector: window.$cookies.get("annualEnergyUseSelector"),
      monthlyEnergyUseSelector: window.$cookies.get("monthlyEnergyUseSelector")
    }
  }
}
</script>
<style>
body, html {
    height: 100%;
    margin: 0;
    background-color: #93a1be;
  }

  .hero {
    padding-top: 75px;
  }

  .body-text {
    font-weight: 300;
    color: lightgrey;
    padding: 20px;
    margin: 0 auto;
  }

  .body-text h1 {
    margin: 0 auto;
  }

  #app {
    font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #ffffff;
    margin: 0 auto;
  }

  #main_img {
    max-width: 100%;
  }

  h1, h2 {
    font-weight: 300;
    padding: 20px;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  label {
    margin-top: 10px;
    font-weight: 300;
  }

  .classification {
    width: 10%;
    text-align: center;
  }

  .hideme {
    display: none;
  }

  .data-display {
    padding-top: 20px;
    padding-bottom: 21px;
    margin-top: 20px;
  }

  .custom-wrapper {
    width: 90%;
    margin: 0 auto;
    background-color: #00395e;
    padding: 30px;
    border-radius: 5px;
    opacity: 0.95;
  }

  .custom-card {
    width: 250px;
    margin: auto;
    margin-top: 15px;
    margin-bottom: 10px;
    padding: 10px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    border-radius: 5px;
    background-color: #4c7636;
  }

  .custom-card:hover {
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.6);
  }

  .custom-form {
    margin-top: 10px;
    text-align: left;
  }

  .modal-content {
    color: black;
  }

   #description_modal_link {
    cursor: pointer;
  }

  .bg-dark {
    background-color: #00395e;
  }

  .custom-buttons {
    margin: 0 auto;
  }

  .custom-buttons button {
    margin: 10px;
  }

  button.btn.btn-lg {
    padding: 20px;
  }

  .table td, .table th {
    padding: .3rem;
    width: 10%;
  }

  .row.container h2 {
    margin: 0 auto;
  }

  .thankyou {
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/ThankYou.vue